<template>
  <!-- TODO: 增加支持富文本：字体、颜色、大小等 -->
  <!-- TODO: webrtc 屏幕共享 -->
  <div id="bd-input">
    <div id="bd-toolbar">
      <el-tooltip :content="emojiTip" placement="top">
        <li id="bd-emoji" class="iconfont icon-emoji" @click="switchEmoji"></li>
      </el-tooltip>
      <transition name="showbox">
        <div class="bd-emoji-box" v-show="showEmoji">
          <li v-for="item in emojis" :key="item.file">
            <img
              :src="emotionUrl(item.file)"
              :data="item.title"
              @click="emotionClicked(item.title)"
            />
          </li>
        </div>
      </transition>
      <!-- TODO: 匹配关键词高亮显示 -->
      <transition name="showbox">
        <div class="bd-input-tip" v-show="showInputTip">
          <ul>
            <li
              v-for="tip in inputTips"
              :key="tip"
              @click="inputTipClicked(tip)"
            >
              {{ tip }}
            </li>
          </ul>
        </div>
      </transition>
      <el-upload
        class="bd-upload-image"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :on-exceed="handleExceed"
        :file-list="uploadedImageList"
        :data="upload_data"
        :name="upload_name"
        :action="uploadImageServerUrl"
        :show-file-list="false"
        :on-success="handleImageUploadSuccess"
        :before-upload="beforeImageUpload"
        :disabled="monitorDisabled"
      >
        <el-tooltip :content="pictureTip" placement="top">
          <li class="iconfont icon-image"></li>
        </el-tooltip>
      </el-upload>
      <el-upload
        class="bd-upload-file"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :on-exceed="handleExceed"
        :file-list="uploadedImageList"
        :data="upload_data"
        :name="upload_name"
        :action="uploadFileServerUrl"
        :show-file-list="false"
        :on-success="handleFileUploadSuccess"
        :before-upload="beforeFileUpload"
        :disabled="monitorDisabled"
      >
        <el-tooltip :content="fileTip" placement="top">
          <li class="iconfont icon-file"></li>
        </el-tooltip>
      </el-upload>
      <!-- <el-tooltip content="邀请评价" placement="top">
        <li id='bd-rate' class='iconfont icon-rate' @click="showInviteRate" :disabled="monitorDisabled"></li>
      </el-tooltip> -->
      <el-tooltip :content="blacklistTip" placement="top">
        <li
          id="bd-block"
          class="iconfont icon-block"
          @click="showBlockDialog"
          :disabled="monitorDisabled"
        ></li>
      </el-tooltip>
      <!-- FIXME: currentThread变化之后，消息预知未变化 -->
      <li id="bd-tip" v-if="inputTipVisible">{{ previewContent }}</li>
      <!-- <el-button v-if="isTypeThread(userCurrentMonitorThread)" size="mini" type="text" @click="showHistoryThread" :disabled="monitorDisabled" style="float: right; margin-top: 3px; margin-right: 15px;">历史会话</el-button> -->
    </div>
    <div id="bd-inputbox">
      <el-input
        id="myInput"
        v-focus
        type="textarea"
        :rows="4"
        :placeholder="inputTip"
        v-model="inputContent"
        @input="onInputChange"
        @keyup.enter.native="onKeyUp"
        debounce="1500"
        maxlength="500"
        show-word-limit
      ></el-input>
      <el-button
        class="sendbutton"
        @click="sendMessage"
        :disabled="sendButtonDisabled"
        >发 送</el-button
      >
    </div>
    <!-- 拉黑对话框 -->
    <el-dialog
      :title="blockReasonTitle"
      :visible.sync="blockDialogVisible"
      width="30%"
      center
    >
      <!-- TODO: 添加拉黑时长到日期之后自动取消拉黑，或者永久拉黑 -->
      <el-input
        type="textarea"
        :rows="4"
        :placeholder="blockReasonTip"
        v-model="blockReason"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blockDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button type="primary" @click="doBlock">{{ $t("block") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import html2canvas from 'html2canvas'
import { mapActions, mapGetters, mapState } from "vuex";
// import BdMessage from '@/components/dashboard/main/chat/children/BdMessage'
// import * as constants from '@/util/constants'
import bus from "@/util/eventbus";
const constants = require("@/util/constants");

export default {
  name: "bd-input",
  data() {
    return {
      show_emoji: false,
      inputContent: "",
      previewContent: "",
      blockReason: "",
      drawerDirection: "rtl",
      // 上传图片相关参数
      upload_headers: {
        "X-CSRF-TOKEN": "",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        Authorization: "Bearer ",
      },
      upload_data: {
        file_name: "test.png",
        username: "",
      },
      upload_name: "file",
      // 接收图片服务器地址
      uploadImageServerUrl: constants.UPLOAD_IMAGE_URL,
      uploadFileServerUrl: constants.UPLOAD_FILE_URL,
      // 上传图片结果集, 格式：{name: '', url: ''}
      uploadedImageList: [],
      uploadFileType: "",
      //
      inputTipVisible: false,
      searchMessage: "",
      blockDialogVisible: false,
      //
      inputing: this.$t("typing"),
      formOptions: [
        this.$t("name"),
        this.$t("mobile"),
        this.$t("age"),
        this.$t("job"),
        this.$t("email"),
      ],
      checkedFormItems: [this.$t("name"), this.$t("mobile")],
    };
  },
  // components: { BdMessage },
  computed: {
    ...mapGetters([
      "userInfo",
      "monitorDisabled",
      "userCurrentMonitorThread",
      "showAuthority",
      "allCuws",
    ]),
    ...mapState(["emojis"]),
    emojiTip() {
      return this.$t("emoji");
    },
    pictureTip() {
      return this.$t("picture");
    },
    fileTip() {
      return this.$t("file");
    },
    inviteRateTip() {
      return this.$t("inviteRate");
    },
    captureTip() {
      return this.$t("captureTip");
    },
    blacklistTip() {
      return this.$t("block");
    },
    formTip() {
      return this.$t("myform");
    },
    formDialogTitle() {
      return this.$t("myform");
    },
    inputTip() {
      return this.$t("inputTip");
    },
    blockReasonTitle() {
      return this.$t("blockReasonTitle");
    },
    blockReasonTip() {
      return this.$t("blockReasonTip");
    },
    showEmoji() {
      return !this.monitorDisabled && this.show_emoji;
    },
    showInputTip() {
      return (
        !this.monitorDisabled &&
        this.inputContent.length > 0 &&
        this.inputTips.length > 0
      );
    },
    inputTips() {
      let tips = [];
      for (let z = 0; z < this.allCuws.length; z++) {
        const cate = this.allCuws[z];
        for (let i = 0; i < cate.cuwChildren.length; i++) {
          const category = cate.cuwChildren[i];
          for (let j = 0; j < category.cuwChildren.length; j++) {
            const cuw = category.cuwChildren[j];
            if (
              this.inputContent.length > 0 &&
              cuw.name != null && cuw.name.indexOf(this.inputContent) !== -1
            ) {
              tips.push(cuw.name);
            }
          }
        }
      }
      return tips;
    },
    sendButtonDisabled() {
      return this.monitorDisabled || this.inputContent.trim().length === 0;
    },
    prePageButtonDisabled() {
      return this.userCurrentMonitorThread.first;
    },
    nextPageButtonDisabled() {
      return this.userCurrentMonitorThread.last;
    },
    showCaptureFunction() {
      return constants.IS_ELECTRON && this.showAuthority.debug;
    },
  },
  methods: {
    ...mapActions("mqtt", ["sendMessageProtobuf"]),
    ...mapActions([
      "updateCurrentThread",
      "inviteRate",
      "addBlock",
      "getMessages",
    ]),
    isDisabled() {
      return this.userCurrentMonitorThread.id === 0;
    },
    isTypeThread(thread) {
      return thread.type === constants.THREAD_TYPE_WORKGROUP;
    },
    switchEmoji() {
      if (!this.monitorDisabled) {
        this.show_emoji = !this.show_emoji;
      }
    },
    emotionUrl(file) {
      return constants.EMOJI_BASE_URL + file;
    },
    emotionClicked(emotion) {
      this.inputContent += emotion;
      this.show_emoji = false;
    },
    inputTipClicked(tip) {
      // 注意：末尾加空格，方便点击之后隐藏tip框
      // TODO: 增加统计CUW使用频次
      this.inputContent = tip + " ";
    },
    /**
     * 上传图片相关函数
     */
    handleRemove(file, uploadedImageList) {
      console.log(file, uploadedImageList);
      // 删除
      for (var i = 0; i < this.uploadedImageList.length; i++) {
        if (this.uploadedImageList[i].url === file.url) {
          this.uploadedImageList.splice(i, 1);
        }
      }
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, uploadedImageList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + uploadedImageList.length} 个文件`
      );
    },
    beforeRemove(file, uploadedImageList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleImageUploadSuccess(result, file) {
      console.log("upload image success result:", result, " file:", file);
      if (result.status_code === 200) {
        // 发送消息
        let url = result.data;
        let payload = {
          type: constants.MESSAGE_TYPE_IMAGE,
          content: url,
          thread: this.userCurrentMonitorThread,
        };
        this.sendMessageProtobuf(payload);
      } else {
        this.$message.error("上传图片错误，请稍后重试...");
      }
    },
    beforeImageUpload(file) {
      // console.log('before image upload file:', file)
      const isJPGorPNG =
        file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // 验证图片格式
      if (!isJPGorPNG) {
        this.$message.error("上传头像图片只能是 jpg 或 png 格式!");
      }
      // 验证图片大小
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      // 设置文件名
      let filename = moment(new Date()).format("YYYYMMDDHHmmss");
      if (file.type === "image/jpeg") {
        this.upload_data.file_name = filename + ".jpg";
      } else if (file.type === "image/png") {
        this.upload_data.file_name = filename + ".png";
      }
      // 返回
      return isJPGorPNG && isLt2M;
    },
    beforeFileUpload(file) {
      // file.name包含文件后缀
      this.upload_data.file_name = file.name;
      // 文件大小控制在2m之内
      this.uploadFileType = file.type;
      const isLt2M = file.size / 1024 / 1024 < 2;
      return isLt2M;
    },
    handleFileUploadSuccess(result, file) {
      console.log("upload file success result:", result, " file:", file);
      if (result.status_code === 200) {
        let url = result.data;
        const isJPGorPNG =
          this.uploadFileType.type === "image/jpeg" ||
          this.uploadFileType.type === "image/png";
        if (isJPGorPNG) {
          // this.sendImageMessage(url)
          let payload = {
            type: constants.MESSAGE_TYPE_FILE,
            content: url,
            thread: this.userCurrentMonitorThread,
          };
          this.sendMessageProtobuf(payload);
        } else {
          let payload = { fileUrl: url, format: this.uploadFileType };
          this.sendFileMessage(payload);
        }
      } else {
        this.$message.error("上传文件错误，请稍后重试...");
      }
    },
    // 邀请评价
    // TODO: 收到访客评价之后，禁止重复邀请
    // showInviteRate () {
    //   // 判断是否disable状态
    //   if (this.monitorDisabled) {
    //     return
    //   }
    //   let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_INVITE_RATE, content: '邀请访客评价', thread: this.userCurrentMonitorThread }
    //   this.sendMessageProtobuf(payload)
    // },
    handleDrawerClose(done) {
      done();
    },
    // 截图
    showCaptureDialog() {
      console.log("show capture");
      // 浏览器截图: http://html2canvas.hertzen.com/getting-started
      // html2canvas(document.body).then(function (canvas) {
      //   // document.body.appendChild(canvas)
      // })
    },
    // 电话
    showPhoneDialog() {
      console.log("show phone");
    },
    // 黑名单
    showBlockDialog() {
      this.blockDialogVisible = true;
    },
    // 拉黑
    doBlock() {
      if (this.blockReason.trim().length > 0) {
        // let payload = { uid: this.userCurrentMonitorThread.visitor.uid, type: '默认类型', note: this.blockReason }
        // this.addBlock(payload)
        // this.blockDialogVisible = false
        // this.userCurrentThread.uid
        let uid = this.userCurrentMonitorThread.topic.split("/")[1]; // 访客uid
        // 加入黑名单 type: '默认类型',
        let payload = { uid: uid, note: this.blockReason };
        this.addBlock(payload);
        this.blockDialogVisible = false;
      } else {
        this.$message.error(this.$t("blockReasonNull"));
      }
    },
    // 输入框内容发生变化
    onInputChange(content) {
      // 判断是否disable状态
      if (this.monitorDisabled) {
        return;
      }
      // 发送消息预知
      let contentTrim = content.trim();
      let payload = {
        type: constants.MESSAGE_TYPE_NOTIFICATION_PREVIEW,
        content: contentTrim,
        thread: this.userCurrentMonitorThread,
      };
      this.sendMessageProtobuf(payload);
    },
    // 发送消息
    onKeyUp(e) {
      if (e.keyCode === 13 && this.inputContent.trim().length > 0) {
        this.sendMessage();
      }
    },
    sendMessage() {
      // TODO: 本地首先显示，不需要等待服务器回执
      if (this.monitorDisabled) {
        return;
      }
      // TODO: 判断是否连接断开
      this.show_emoji = false;
      let content = this.inputContent.trim();
      if (content.length > 0) {
        let payload = {
          type: constants.MESSAGE_TYPE_TEXT,
          content: content,
          thread: this.userCurrentMonitorThread,
        };
        this.sendMessageProtobuf(payload);
        this.inputContent = "";
      }
    },
    uploadImage(file) {
      //
      let filename = moment(new Date()).format("YYYYMMDDHHmmss");
      if (file.type === "image/jpeg") {
        filename = filename + ".jpg";
      } else if (file.type === "image/png") {
        filename = filename + ".png";
      }
      //
      var formdata = new FormData();
      formdata.append("file_name", filename);
      formdata.append("username", this.userInfo.username);
      formdata.append("file", file);
      // formdata.append("client", 'web');
      //
      let app = this;
      $.ajax({
        url: this.uploadImageServerUrl,
        contentType: false,
        cache: false,
        processData: false,
        mimeTypes: "multipart/form-data",
        type: "post",
        data: formdata,
        success: function(response) {
          console.log("upload response:", response.data);
          var imageUrl = response.data;
          let payload = {
            type: constants.MESSAGE_TYPE_IMAGE,
            content: imageUrl,
            thread: app.userCurrentThread,
          };
          app.sendMessageProtobuf(payload);
        },
        error: function(error) {
          console.log(error);
          app.$notify({
            title: app.$t("tip"),
            message: app.$t("sendImageError"),
            type: "error",
          });
        },
      });
    },
    imgReader(item) {
      var file = item.getAsFile();
      this.uploadImage(file);
    },
    prePage() {},
    nextPage() {
      let size = 20;
      this.getMessages(size);
    },
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus();
      },
    },
  },
  mounted() {
    // 点击快捷回复
    bus.$on(constants.EVENT_BUS_SELECT_CUW, (cuw) => {
      if (this.monitorDisabled) {
        return;
      }
      this.inputContent += cuw;
    });
    // 消息预知
    let app = this;
    bus.$on(constants.EVENT_BUS_MESSAGE_PREVIEW, (message) => {
      // console.log(message.content)
      if (message.thread.tid === this.userCurrentMonitorThread.tid) {
        app.inputTipVisible = true;
        if (message.content.trim().length > 0) {
          this.previewContent = app.inputing + message.content;
        } else {
          this.previewContent = "";
        }
        // 5s 定期清空状态
        setTimeout(function() {
          app.inputTipVisible = false;
        }, 5000);
      }
    });
    //
    document.getElementById("myInput").addEventListener("paste", function(e) {
      // 添加到事件对象中的访问系统剪贴板的接口
      var clipboardData = e.clipboardData,
        i = 0,
        items,
        item,
        types;
      if (clipboardData) {
        items = clipboardData.items;
        if (!items) {
          return;
        }
        item = items[0];
        // 保存在剪贴板中的数据类型
        types = clipboardData.types || [];
        for (; i < types.length; i++) {
          if (types[i] === "Files") {
            item = items[i];
            break;
          }
        }
        // 判断是否为图片数据
        if (item && item.kind === "file" && item.type.match(/^image\//i)) {
          app.imgReader(item);
        }
      }
    });
  },
};
</script>

<style scoped>
#bd-input {
  width: 100%;
  height: 130px;
  background: #fff;
  border-top: solid 0.1px #dddddd;
}
#bd-emoji {
  float: left;
  margin-top: 11px;
  margin-left: 20px;
  cursor: pointer;
  list-style: none;
}
.bd-emoji-box {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  margin-top: -295px;
  width: 280px;
  height: 280px;
  padding: 3px 6px 6px 14px;
  background-color: #fff;
  border: 1px solid #d1d1d1;
  border-radius: 2px;
  box-shadow: 0 1px 2px 1px #d1d1d1;
}
.bd-emoji-box li {
  list-style: none;
  width: 24px;
  margin-top: 15px;
  margin-left: 5px;
  border: none;
  margin-bottom: 0px;
}
.bd-emoji-box.showbox-enter-active,
.bd-emoji-box.showbox-leave-active {
  transition: all 0.5s;
}
.bd-emoji-box.showbox-enter,
.bd-emoji-box.showbox-leave-active {
  opacity: 0;
}
.bd-input-tip {
  position: absolute;
  bottom: 142px;
  width: 300px;
  padding: 3px 6px 6px 10px;
  background-color: #fff;
  border: 1px solid #d1d1d1;
  text-align: left;
}
.bd-input-tip li {
  list-style: none;
  margin-top: 5px;
  border: none;
  cursor: pointer;
}
.bd-input-tip.showbox-enter-active,
.bd-input-tip.showbox-leave-active {
  transition: all 0.5s;
}
.bd-input-tip.showbox-enter,
.bd-input-tip.showbox-leave-active {
  opacity: 0;
}
.bd-upload-image {
  font-size: 25px;
  color: gray;
  margin-left: 20px;
  cursor: pointer;
  float: left;
  list-style: none;
}
.bd-upload-file {
  font-size: 25px;
  color: gray;
  margin-left: 20px;
  cursor: pointer;
  float: left;
  list-style: none;
}
#bd-rate {
  float: left;
  margin-top: 11px;
  margin-left: 18px;
  color: gray;
  cursor: pointer;
  list-style: none;
  font-size: 15px;
}
#bd-jietu {
  float: left;
  margin-top: 9px;
  margin-left: 20px;
  cursor: pointer;
  list-style: none;
  font-size: 18px;
}
#bd-video {
  float: left;
  margin-top: 9px;
  margin-left: 20px;
  cursor: pointer;
  list-style: none;
  font-size: 18px;
}
#bd-phone {
  float: left;
  margin-top: 7px;
  margin-left: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 20px;
}
#bd-block {
  float: left;
  margin-top: 8px;
  margin-left: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 19px;
}
#bd-tip {
  float: left;
  margin-top: 9px;
  margin-left: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 10px;
}
.sendbutton {
  /* position: absolute;
  bottom: 35px;
  right: 3%; */
  position: relative;
  bottom: 55px;
  right: -250px;
}
</style>
